import script from "./AssistantChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssistantChat.vue?vue&type=script&setup=true&lang=ts"

import "./AssistantChat.vue?vue&type=style&index=0&id=04f314c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f314c1"]])

export default __exports__